import script from "./Faqs_66.vue?vue&type=script&setup=true&lang=js"
export * from "./Faqs_66.vue?vue&type=script&setup=true&lang=js"

import "./Faqs_66.vue?vue&type=style&index=0&id=b2e92850&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b2e92850"]])

export default __exports__